import { config } from "@/config";
import { useFlow } from "@frigade/react";
import * as Frigade from "@frigade/react";
import { OnboardingSteps } from "../OnboardingGuide";
import { useAppState } from "@/store/useApp";
import OnboardingFlow from "./OnboardingFlow";

const OnboardingShareFeedbackHintFlow = () => {
  const { flow } = useFlow(config.frigade.flows.gettingStarted);
  const { flow: feedbackFlow } = useFlow(config.frigade.flows.feedbackHint);
  const currentStep = flow?.getCurrentStep();
  const grading = useAppState((state) => state.grading);

  if (
    feedbackFlow?.isCompleted &&
    (currentStep?.id as OnboardingSteps) === "publish_feedback" &&
    grading?.grade
  ) {
    return (
      <OnboardingFlow>
        <Frigade.Tour
          flowId={config.frigade.flows.shareFeedbackHint}
          defaultOpen={true}
        />
      </OnboardingFlow>
    );
  }
};

export default OnboardingShareFeedbackHintFlow;
